export default function UploadRate() {
  return (
    <>
      <h1>Upload Rate</h1>
    </>
  );
}
